import { create } from 'zustand';

export interface Agent {
  id: string;
  name: string;
  colour: string;
  ordinal: number;
  focus_areas: string[];
}

export interface SessionMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  created_at: string;
}

interface SessionState {
  messages: SessionMessage[];
  isStreaming: boolean;
  currentAgent: Agent | null;
  sessionId: string | null;

  // Actions
  addMessage: (message: SessionMessage) => void;
  setStreaming: (value: boolean) => void;
  setAgent: (agent: Agent | null) => void;
  setSessionId: (id: string | null) => void;
  clearSession: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  messages: [],
  isStreaming: false,
  currentAgent: null,
  sessionId: null,

  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),

  setStreaming: (value) => set({ isStreaming: value }),

  setAgent: (agent) => set({ currentAgent: agent }),

  setSessionId: (id) => set({ sessionId: id }),

  clearSession: () =>
    set({
      messages: [],
      isStreaming: false,
      currentAgent: null,
      sessionId: null,
    }),
}));
